var map = {
	"./pages/Error.vue": [
		6889,
		6889
	],
	"./pages/NewsFeed.vue": [
		47577,
		1889,
		7577
	],
	"./pages/end/LolEnd.vue": [
		79092,
		1889,
		683,
		6564,
		9092
	],
	"./pages/end/TftEnd.vue": [
		86377,
		1889,
		683,
		6564,
		6377
	],
	"./pages/end/ValEnd.vue": [
		41473,
		1889,
		683,
		6564,
		1473
	],
	"./pages/end/WrEnd.vue": [
		66539,
		1889,
		683,
		6564,
		6539
	],
	"./pages/gameHome/LolHome.vue": [
		76186,
		1889,
		683,
		30,
		6416,
		9491,
		6186
	],
	"./pages/gameHome/LoldocupHome.vue": [
		6925,
		1889,
		683,
		30,
		8414,
		6925
	],
	"./pages/gameHome/ValorantHome.vue": [
		19724,
		1889,
		683,
		30,
		5411,
		6416,
		9724
	],
	"./pages/gameHome/WrHome.vue": [
		17849,
		1889,
		683,
		30,
		6416,
		7849
	],
	"./pages/landing/LandingHome.vue": [
		54517,
		4517
	],
	"./pages/lol/AcademyLanding.vue": [
		79279,
		1889,
		9279
	],
	"./pages/lol/LolLeaderboard.vue": [
		21560,
		1889,
		9491,
		1560
	],
	"./pages/loldocup/LoldocupEvent.vue": [
		8284,
		1889,
		8284
	],
	"./pages/loldocup/LoldocupIntro.vue": [
		82628,
		1889,
		8414,
		2628
	],
	"./pages/loldocup/LoldocupResult.vue": [
		52282,
		1889,
		2282
	],
	"./pages/tftWeeklyCup/TftHome.vue": [
		32415,
		1889,
		683,
		30,
		6416,
		2415
	],
	"./pages/tftWeeklyCup/TftIntro.vue": [
		7784,
		1889,
		7784
	],
	"./pages/tftWeeklyCup/TftResult.vue": [
		525,
		1889,
		525
	],
	"./pages/valorant/ShotValLanding.vue": [
		73410,
		1889,
		3410
	],
	"./pages/valorant/ValorantLeaderboard.vue": [
		81342,
		1889,
		1342
	],
	"./pages/wildRift/WariwariLanding.vue": [
		24523,
		1889,
		4523
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 12912;
module.exports = webpackAsyncContext;